import React from 'react';

type Props = {
  title: string,
  subtitle: string,
  brandDescription: string,
  avatarIcon: React.ReactNode,
  children: React.ReactNode,
  cardClassName?: string,
};

const RoofIllustration = () => (
  <svg
    className="auth-brand__illustration"
    viewBox="0 0 240 84"
    role="img"
    aria-label="Solar modules on a roof"
  >
    <path className="auth-brand__roof" d="M11 73 L112 8 L229 73 Z" />
    <g className="auth-brand__modules">
      <rect x="24" y="49" width="21" height="19" rx="1" />
      <rect x="48" y="49" width="21" height="19" rx="1" />
      <rect x="72" y="49" width="21" height="19" rx="1" />
      <rect x="36" y="26" width="21" height="19" rx="1" />
      <rect x="60" y="26" width="21" height="19" rx="1" />
    </g>
  </svg>
);

const AuthLayout = ({ title, subtitle, brandDescription, avatarIcon, children, cardClassName = '' }: Props) => {
  const titleId = title.toLowerCase().replace(/\s+/g, '-');

  return (
    <div className="auth-page-shell">
      <section className={`auth-card auth-layout ${cardClassName}`} aria-labelledby={titleId}>
        <aside className="auth-brand" aria-label="About U-Builder">
          <div className="auth-brand__name">U-Builder</div>
          <h2 className="auth-brand__statement">
            Solar design<br />
            software,<br />
            point, click, scale.
          </h2>
          <p className="auth-brand__description">{brandDescription}</p>
          <RoofIllustration />
        </aside>

        <div className="auth-panel">
          <div className="auth-mobile-avatar" aria-hidden="true">
            {avatarIcon}
          </div>
          <header className="auth-heading">
            <h1 id={titleId}>{title}</h1>
            <p>{subtitle}</p>
          </header>
          {children}
        </div>
      </section>
    </div>
  );
};

export default AuthLayout;
